import React from "react";
import Cover from "../assets/Cover.png";
import icon from "../assets/teachwithus/icon.png";
import icona from "../assets/teachwithus/icona.png";
import iconb from "../assets/teachwithus/iconb.png";
import iconc from "../assets/teachwithus/iconc.png";
import icond from "../assets/teachwithus/icond.png";
import icone from "../assets/teachwithus/icone.png";
import iconf from "../assets/teachwithus/iconf.png";
import ImageGroup from "../assets/teachwithus/ImageGroup.png";
import cuate from "../assets/teachwithus/cuate.png";
function TeachwithUs() {
  return (
    <div className="teach_with_us">
      <div className="img_container">
        <img src={Cover} className="header_image mt-5" alt="teach with us" />
        <h1>TEACH WITH US</h1>
        <div className="small_card">
          <h2>Become a Clapingo Instructor :)</h2>
          <p>
            We are looking for a dynamic crowd from different backgrounds. If
            you have excellent English communication skills and some free time,
            join us and help Learners across the globe tackle their English
            speaking challenges. This part-time job is flexible and will help
            you upskill yourself while making a steady weekly income. For more
            information- Check out our speaker testimonials!
          </p>
          <button
            onClick={() =>
              (window.location.href =
                "https://docs.google.com/forms/d/e/1FAIpQLScqu7OAYYLgYi-j1HY3BApO_p_HpkUn2-g8sG-dWfrPZZpKfQ/viewform")
            }
          >
            Apply
          </button>
        </div>
      </div>
      <div className="become_instructor">
        <h1>
          Why become an
          <br />
          Instructor?
        </h1>
        <div className="row mt-5 points">
          <div className="col-md-6 mb-3">
            <div className="d-flex">
              <img className="icon" src={icon} alt="icon" />
              <div className="ml-4">
                <h3>WORK FROM ANYWHERE</h3>
                <p>
                  Teach learners from the comfort of your own home. Whenever you
                  want and from wherever you want!
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="d-flex">
              <img className="icon" src={icona} alt="icon" />
              <div className="ml-4">
                <h3>WORK WHEN YOU WANT</h3>
                <p>Clapingo Speakers earn money on their own schedule.</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="d-flex">
              <img className="icon" src={iconb} alt="icon" />
              <div className="ml-4">
                <h3>GROW YOUR SKILLS</h3>
                <p>
                  We will mentor you to become an excellent trainer even if you
                  do not have any previous teaching experience/background.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="d-flex">
              <img className="icon" src={iconc} alt="icon" />
              <div className="ml-4">
                <h3>MAKE A REAL DIFFERENCE</h3>
                <p>
                  Use your life experiences and knowledge of the language to
                  transform someone’s life.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="how_to_apply ">
        <h1>SELECTION/Onboarding Process: </h1>
        <div className="row mt-5">
          <div className="col-md-4">
            <img className="icons" src={icond} alt="icon" />
            <h3 className="mt-4">APPLICATION FORM</h3>
            <p>Fill the application by following the instructions. </p>
          </div>
          <div className="col-md-4">
            <img className="icons" src={icone} alt="icon" />
            <h3 className="mt-4">SHOW YOUR SKILLS</h3>
            <p>Show us your skills.</p>
          </div>
          <div className="col-md-4">
            <img className="icons" src={iconf} alt="icon" />
            <h3 className="mt-4">TRAINING</h3>
            <p>
              Attend a mandatory training module (after your application is
              shortlisted) to become a Clapingo Speaker. We provide you with the
              resources and training to deliver the sessions.
            </p>
          </div>
        </div>
      </div>
      <div className="who_can_apply">
        <h1 className="text-center"> Who can apply? </h1>
        <p className="text-center apply_subtitle" >Our platform provides the learners with a safe space to communicate their insecurities and weaknesses. They are looking to have a conversation with people who are fluent in English. We provide them with credible, actionable and practical advice to reach their desired goals. We accept applications from anyone with excellent Communication & conversational skills. 
No prior experience or degree required.
</p>
        <div className="row mt-5">
          <div className="col-md-6">
            <img className="image" src={ImageGroup} alt="img" />
          </div>
          <div className="col-md-6 ">
            <div className="right">
              <div>
                <h3 className="one ">Educators/Experts</h3>
                <p className="pr-3">Anyone with prior teaching experience.</p>
              </div>
              <div>
                <h3 className="two mt-5">UG/PG Students</h3>
                <p className="pr-3">Anyone who is currently enrolled or passed out of college.</p>
              </div>
              <div>
                <h3 className="three mt-5">Working Professionals</h3>
                <p className="pr-3">Anyone who has a full-time/part time job with some time to spare. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-5 pb-5" >
      <div className="join_us">
        <div className="row">
          <div className="col-md-6">
            <h3>Join us and help learners thrive. Apply now!</h3>
            <button
              onClick={() =>
                (window.location.href =
                  "https://docs.google.com/forms/d/e/1FAIpQLScqu7OAYYLgYi-j1HY3BApO_p_HpkUn2-g8sG-dWfrPZZpKfQ/viewform")
              }
              className="mt-4"
            >
              Apply
            </button>
          </div>
          <div className="col-md-6">
            <img className="mt-4 bottom_image" src={cuate} alt="img" />
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default TeachwithUs;
